import React, { useEffect } from "react";
import { Zap } from "lucide-react";
import classnames from "classnames";
import useGameStore from "@store/useGameStore";
import feedback from "@components/ui/general/feedback";

import "./EnergyDisplay.css";

export default function EnergyDisplay({ value }) {
  const currentPlayer = useGameStore((state) => state.currentPlayer);
  //console.log("Active player in EnergyDisplay:", activePlayer.pivot.energy);
  useEffect(() => {
    if (!currentPlayer) {
      feedback.warning("No active player detected in EnergyDisplay.");
    } else if (currentPlayer.pivot?.energy === undefined) {
      console.info("Active player no tiene energia definida",currentPlayer);
      feedback.warning(`Active player [ID: ${currentPlayer.pivot?.id ?? "?"}] has no energy defined.`);
    }
  }, [currentPlayer]);

  if (!currentPlayer || currentPlayer.pivot?.energy === undefined) {
    return (
      <span className="energy-display hollow" title="Energy unavailable">
        ?<Zap className="icon-fixed energy-icon hollow" />
      </span>
    );
  }

  const currentEnergy = currentPlayer.pivot.energy;
  const isEnough = currentEnergy >= value;
  const hollow = !isEnough;

  return (
    <span
      className={classnames("energy-display", { hollow })}
      title={hollow ? `Not enough energy (${currentEnergy}/${value})` : undefined}
    >
      {value}
      <Zap className={classnames("icon-fixed", "energy-icon", { hollow })} />
    </span>
  );
}
